module.exports = __webpack_public_path__ + "media/images/landing/persons/andy-hurychova-8fb5c03ab1f17a437a71e7ecef8363ab.jpg";